import React from 'react';
import { motion } from 'framer-motion';
import { Sparkles, ArrowRight, CheckCircle2 } from 'lucide-react';
const products = [{
  id: 'radiestesia',
  title: '🌿 KIT PROFESIONAL DE RADIESTESIA',
  description: 'Gráficos terapéuticos, protocolos listos, preguntas guiadas y herramientas prácticas para sesiones con péndulo.',
  price: '$19.990 ARS',
  image: 'https://cdn.magicpatterns.com/uploads/dbUJYJn89tdPgaaEGm9iY2/ChatGPT_Image_20_may_2026,_14_41_36.png',
  buttonText: 'QUIERO ESTE KIT'
}, {
  id: 'reiki',
  title: '✨ SISTEMA PROFESIONAL DE REIKI TERAPÉUTICO',
  description: 'Formaciones Reiki nivel 1, 2 y 3, protocolos de sesión, símbolos, meditaciones y herramientas terapéuticas.',
  price: '$19.990 ARS',
  image: 'https://cdn.magicpatterns.com/uploads/hvXJK4NUhXJWRAm9mRfFpp/1b00af68-f628-437e-909d-dc301a18f692.webp',
  buttonText: 'QUIERO ESTE KIT'
}, {
  id: 'constelaciones',
  title: '🪷 CONSTELACIONES FAMILIARES',
  description: 'Herramientas terapéuticas, dinámicas sistémicas y recursos prácticos para acompañar procesos emocionales.',
  price: '$19.990 ARS',
  image: 'https://cdn.magicpatterns.com/uploads/5hVnG5hVQ3ozjUJ1RbQKzJ/3fb58353-4ad6-48eb-9650-c6e23b130f14.webp',
  buttonText: 'QUIERO ESTE KIT'
}, {
  id: 'tarot',
  title: '🔮 TAROT TERAPÉUTICO',
  description: 'Sistema terapéutico de lectura consciente, interpretación profunda y acompañamiento emocional con tarot.',
  price: '$19.990 ARS',
  image: 'https://cdn.magicpatterns.com/uploads/2KaoS3XQTUJRWMp2FktLX3/Libro_Tarot_Terapeutico_Profesio…_202605101407.webp',
  buttonText: 'QUIERO ESTE KIT'
}];
export function PortalTerapeutico() {
  return;
}